import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

 



export const msalConfig = {
  auth: {
    clientId: "f7e54fc1-bbf6-4439-b2de-f3f134b1427a",
    authority: "https://login.microsoftonline.com/9c8d0d3e-b6ba-4ef3-b023-37952c89fc65",
   redirectUri: "https://shaml.awjholding.com/",
 //redirectUri: "http://localhost:3000/",
  },
  cache: {
  cacheLocation: "localStorage",  // persist tokens in localStorage
    storeAuthStateInCookie: true,  // or true if you experience issues with some browsers
 
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        console.log(message);
      },
      piiLoggingEnabled: false,
      LogLevel: LogLevel.Warning,
    },
  },
  // other configs
};

export const loginRequest = {
  scopes: ["User.Read" ,"User.Read.All"],
};
 